(function($){

  /**
   * jQuery plugin: submitAccessCodeForm
   * Validates access code against API and sets cookie on success.
   * 
   * @method $.fn.submitAccessCodeForm
   * @returns {jQuery} jQuery object for chaining
   * @sideEffect Makes AJAX POST to validate code, sets cookie on success, shows error on failure
   * 
   * @example
   * $('.access-code--form').submitAccessCodeForm();
   */
  $.fn.submitAccessCodeForm = function() {
    let form = $(this);
    let domain = form.find('input[name="domain"]').val();
    let code = form.find('input[name="code"]').val();

    // Submit validation request to API
    $.post(`${window.api_base_url}/api/validate`, {domain, code}, function(response) {
        if(response.valid) {
          // Set validation cookie (expires in 1 day)
          setCookie('access_code_validated', 'true', 1);
          closeAccessCodeOverlay();
        } else {
          // Show error message
          form.find('.error').removeClass('hidden');
        }
    }, 'json').fail(function(xhr, status, error) {
          // Error handling - comment shows potential for detailed error messages
          // form.find('.error').html(response.responseJSON.message);
          // form.find('.error').removeClass('hidden');
    });
  };

  /**
   * Document ready handler - initializes access code overlay on page load.
   * Checks if access code validation is required and shows/hides overlay accordingly.
   * 
   * @event DOMContentLoaded
   * @listens jQuery ready event
   * @sideEffect May call openAccessCodeOverlay() or closeAccessCodeOverlay()
   */
  $(function() {
    // Check if already validated
    if(getCookie('access_code_validated') === 'true') {
      closeAccessCodeOverlay();
    }
    // Check if page requires access code validation
    else if($('body').hasClass('has-access-code') && getCookie('access_code_validated') !== 'true') {
      // Check if we should ignore access code (via URL parameter)
      if (window.location.href.indexOf('ignore_access_code') < 0) {
        openAccessCodeOverlay();
      }
      else {
        closeAccessCodeOverlay();
      }
    }
  })

  /**
   * Form submission handler for access code form.
   * Prevents default submission and triggers custom validation.
   * 
   * @event submit
   * @listens .access-code--form
   * @param {Event} e - Submit event
   * @returns {void}
   */
  $(document).on('submit', '.access-code--form', function(e) {
    e.preventDefault();
    $(this).submitAccessCodeForm();
  });

  /**
   * Opens the access code overlay by removing hidden class from container
   * and adding has-access-code class to body.
   * 
   * @function openAccessCodeOverlay
   * @returns {void}
   * @sideEffect Modifies DOM classes to show overlay
   * 
   * @example
   * openAccessCodeOverlay();
   */
  function openAccessCodeOverlay() {
    $('body').addClass('has-access-code');
    $('.access-code-overlay--container').removeClass('hidden');
  }

  /**
   * Closes the access code overlay by adding hidden class to container
   * and removing has-access-code class from body.
   * 
   * @function closeAccessCodeOverlay
   * @returns {void}
   * @sideEffect Modifies DOM classes to hide overlay
   * 
   * @example
   * closeAccessCodeOverlay();
   */
  function closeAccessCodeOverlay() {
    $('body').removeClass('has-access-code');
    $('.access-code-overlay--container').addClass('hidden');
  }
})(jQuery);
